function isPositiveValue(value: string): boolean {
  return !isNaN(Number(value)) && value?.length > 0 && Number(value) >= 0
}

function isToSpecifiedDecimalPlace(
  value: string,
  maxDecimalPlace: number,
): boolean {
  if (maxDecimalPlace < 1 || !Number.isInteger(maxDecimalPlace)) {
    return false
  }
  const regex = new RegExp(`^\\d+(\\.\\d{1,${maxDecimalPlace}})?$`)
  return !isNaN(Number(value)) && value?.length > 0 && regex.test(value)
}

//小数点第二位まで、0から100までの数値のみ許可
export function isRatePercent(value: string): boolean {
  const regex = /^(100(\.00?)?|0(\.\d{1,2})?|[1-9]\d?(\.\d{1,2})?)$/
  return regex.test(value) && isPositiveValue(value)
}

function constructSimplifiedJapanesePattern(): RegExp {
  const katakanaRange = 'ア-ン'
  const specialKatakana = 'ヴ'
  const fullWidthAlphaNumeric = 'ａ-ｚＡ-Ｚ０-９'
  const fullWidthSymbols = '（）．－／「」 　'

  return new RegExp(
    `^[${katakanaRange}${specialKatakana}${fullWidthAlphaNumeric}${fullWidthSymbols}]+$`,
  )
}

function isKanaValue(value: string): boolean {
  const japaneseNamePattern = constructSimplifiedJapanesePattern()
  return japaneseNamePattern.test(value)
}

const CHOONPU_PATTERN = /ー/g

function normalizeChoonpuToHyphen(value: string): string {
  return value.replace(CHOONPU_PATTERN, '－')
}

export const validateUtils = {
  isPositiveValue,
  isToSpecifiedDecimalPlace,
  isRatePercent,
  isKanaValue,
  normalizeChoonpuToHyphen,
}
